
import { Component, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import UnsavedChanges from '@/_components/alert/unsavedChanges/unsavedChanges.vue'
import RichTextField from '@/components/RichTextField/richTextField.vue'

@Component({
    components: { UnsavedChanges, RichTextField },
    mixins: [ProjectMixin],
})
export default class InfoSettings extends Mixins<MixinInterface>(ProjectMixin) {
    @Watch('currentProjectId', { immediate: true })
    watchActiveProject() {
        this.initiatehseBoardDescription()
        this.initiatepublicHseBoardDescription()
    }

    // DESCRIPTION
    get descriptionTools() {
        let isAttachmentsWritable =
            this.currentProject?.attributes?.constraints?.hseBoardDescriptionAttachments
                ?.writable === true
        let tools: Array<any> = []

        if (isAttachmentsWritable) {
            tools.push({
                type: 'VBITImage',
                config: {
                    type: 'hseBoardDescriptionAttachment',
                    links: {
                        related: `${this.url_project}/hseBoardDescriptionAttachments`,
                    },
                    relationships: {
                        project: {
                            data: {
                                type: 'project',
                                id: this.currentProjectId,
                            },
                        },
                    },
                },
            })
        }

        return tools
    }

    // hseBoardDescription
    hseBoardDescription: any = null

    get hseBoardDescriptionBase() {
        return this.$store.getters.project(this.currentProjectId)?.attributes.hseBoardDescription
    }

    initiatehseBoardDescription() {
        this.hseBoardDescription = this.hseBoardDescriptionBase
    }

    // publicHseBoardDescription
    publicHseBoardDescription: any = null

    get publicHseBoardDescriptionBase() {
        return this.$store.getters.project(this.currentProjectId)?.attributes
            .publicHseBoardDescription
    }

    initiatepublicHseBoardDescription() {
        this.publicHseBoardDescription = this.publicHseBoardDescriptionBase
    }

    // Track changes
    get stagedChanges() {
        let result = {
            ...(!this.isEqualRichText(this.hseBoardDescription, this.hseBoardDescriptionBase) && {
                hseBoardDescription: this.hseBoardDescription,
            }),
            ...(!this.isEqualRichText(
                this.publicHseBoardDescription,
                this.publicHseBoardDescriptionBase
            ) && { publicHseBoardDescription: this.publicHseBoardDescription }),
        }
        return result
    }

    get hasStagedChanges() {
        return !this.isObjectEmpty(this.stagedChanges)
    }

    // Cancle changes
    cancel() {
        this.initiatehseBoardDescription()
        this.initiatepublicHseBoardDescription()
    }

    // UPDATE
    loading = false

    async updateProject() {
        this.loading = true

        try {
            let params = {
                data: {
                    type: 'project',
                    id: this.currentProjectId,
                    attributes: {
                        ...this.stagedChanges,
                    },
                },
                updatedAt: new Date().toUTCString(),
            }

            await this.patchProject(params)
        } catch (error) {
            //
        }

        this.loading = false
    }
}
